// import assert from 'assert';
import classNames from 'classnames';
import React from 'react';
import { useFormSettingsContext } from '../form/Form.context';
import {
  clsPrefix,
  SegmentedControlSC,
  SegmentedFloat,
  SegmentedItem,
} from './segmented-control.styled';
import { SegmentedControlProps, TComp } from './segmented-control.types';
import { getItemClass } from './segmented-control.utils';

type TSize = { left: number; width: number; top: number; height: number };

const SegmentedControl = <T extends unknown>(
  props: SegmentedControlProps<T>,
  forwardedRef?: React.Ref<HTMLDivElement>,
) => {
  const { className, options, value, onChange, variant = 'on-light', disabled, ...rest } = props;
  const settings = useFormSettingsContext({ variant, disabled });
  const [sizes, setSizes] = React.useState<TSize[]>([]);
  const activeIdx = options.findIndex((o) => o.value === value);

  // assert(
  //   options.length >= 1 && options.length <= 4,
  //   `Expected between 1 and 4 (got: ${options.length})`,
  // );

  return (
    <SegmentedControlSC
      {...rest}
      ref={forwardedRef}
      className={classNames(clsPrefix, className, settings.variant)}
    >
      <SegmentedFloat
        className={classNames(getItemClass(true, activeIdx, options.length), variant)}
        style={{
          transform: `translate(${sizes[activeIdx]?.left - 2 ?? 0}px, ${
            sizes[activeIdx]?.top - 2 ?? 0
          }px)`,
          width: sizes[activeIdx]?.width ?? 0,
          height: sizes[activeIdx]?.height ?? 0,
          visibility: sizes[activeIdx] === undefined ? 'hidden' : 'visible',
        }}
      />
      {options.map((o, idx) => (
        <SegmentedItem
          disabled={settings.disabled || o.disabled}
          tabIndex={idx}
          key={o.key}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => onChange?.(o.value, e)}
          className={classNames(
            `${clsPrefix}-item`,
            settings.variant,
            getItemClass(value === o.value, idx, options.length),
            { default: value === o.value && sizes[idx] === undefined },
          )}
          onLayout={(e) => {
            setSizes((o) => {
              const next = [...o];
              next[idx] = {
                width: e.nativeEvent.layout.width,
                left: e.nativeEvent.layout.x,
                top: e.nativeEvent.layout.y,
                height: e.nativeEvent.layout.height,
              };
              return next;
            });
          }}
        >
          {o.label}
        </SegmentedItem>
      ))}
    </SegmentedControlSC>
  );
};

export default React.forwardRef(SegmentedControl) as TComp;
